import superagent from 'superagent'

function getCookieValue(cookieName) {
  const cookies = document.cookie.split('; ')
  return cookies.find(cookie => cookie.indexOf(cookieName) === 0)
}

function getHeaders() {
  const headers = { Accept: `application/json` }
  if (window.stubEnabled === 'true') {
    const dysonCookie = getCookieValue('dyson_findability_session')
    if (dysonCookie) {
      return {
        Cookie: `dyson_findability_session=${dysonCookie}`,
        ...headers
      }
    }
  }
  return headers
}

export default function hookLogicService(hookLogicUrl) {
  const responseTimeout = window.criteoResponseTimeout !== 'undefined' ? window.criteoResponseTimeout : 1000
  const deadlineTimeout = window.criteoDeadlineTimeout !== 'undefined' ? window.criteoDeadlineTimeout : 2000

  const parseResponseText = text => {
    try {
      return JSON.parse(text)
    } catch (error) {
      return {}
    }
  }
  return new Promise((resolve, reject) => {
    superagent
      .get(hookLogicUrl)
      .set(getHeaders())
      .timeout({
        response: responseTimeout,
        deadline: deadlineTimeout
      })
      .end((err, response) => {
        if (err) {
          resolve({ timeout: true })
        }
        if (response && response.text) {
          resolve(parseResponseText(response.text))
        }
      })
  })
}
